// ─────────────────────────────────────────────────────────────────────────────
// 🔑 EVA STAYS OFF WHILE AN ATTESTATION IS OPEN, ON ANY STEP (2026-10-16).
//
// The shell keeps Eva off the consent steps (evaAllowedOn reads each step's `consent`). Some attestations
// open inside a step that is not a consent step — the individual-intent statement on withdrawing a
// co-borrower invite, from step 6. A component that renders one calls useAttestationOpen(); the shell
// reads useAnyAttestationOpen() and hides Eva while any is on screen. backend/test/guidedFlowShell holds
// every consent control to a consent step OR this hook.
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect, useState } from 'react';

const EVENT = 'doorly:attestation';
let open = 0;

export function useAttestationOpen() {
  useEffect(() => {
    open += 1;
    window.dispatchEvent(new CustomEvent(EVENT, { detail: open }));
    return () => {
      open = Math.max(0, open - 1);
      window.dispatchEvent(new CustomEvent(EVENT, { detail: open }));
    };
  }, []);
}

export function useAnyAttestationOpen() {
  const [count, setCount] = useState(open);
  useEffect(() => {
    const on = (e) => setCount(Number(e.detail) || 0);
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return count > 0;
}
